import { render, staticRenderFns } from "./message-detail.vue?vue&type=template&id=e6763a88&scoped=true&lang=pug"
import script from "./message-detail.vue?vue&type=script&lang=js"
export * from "./message-detail.vue?vue&type=script&lang=js"
import style0 from "./message-detail.vue?vue&type=style&index=0&id=e6763a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6763a88",
  null
  
)

export default component.exports